import { getIdToken } from 'firebase/auth';
import { auth } from './firebase';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000';

const readError = async (res) => {
  try {
    const data = await res.json();
    if (data?.detail) return data.detail;
    if (data?.message) return data.message;
  } catch {
    // ignore
  }
  try {
    const text = await res.text();
    if (text) return text;
  } catch {
    // ignore
  }
  return `Request failed (${res.status})`;
};

export const backendSendVerificationEmail = async () => {
  if (!auth.currentUser) {
    throw new Error('No signed-in user.');
  }
  const idToken = await getIdToken(auth.currentUser);
  const res = await fetch(`${apiBaseUrl}/api/auth/send-verification`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ idToken }),
  });
  if (!res.ok) {
    throw new Error(await readError(res));
  }
};

export const backendSendPasswordReset = async (email) => {
  const res = await fetch(`${apiBaseUrl}/api/auth/password-reset`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  if (!res.ok) {
    throw new Error(await readError(res));
  }
};
